import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "3.23vh",
            height: "153vw"
        },
        card: {
            width: "100%",
            height: "153vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "3.78vw",
            height: "60vw"
        },
        card: {
            height: "60vw"
        }
    }
};

export const TableLoader: React.FC = () => {
    const inputLoaderCount = 10;
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;

    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="0%" y="0%" rx="5" ry="5" width="100%" height="15vw"/>
                        {Array.from({ length: inputLoaderCount }).map((_, i) => (
                            <rect key={i} x="0%" y={`${16 + i * 14}vw`} rx="5" ry="5" width="100%" height="12vw"/>
                        ))}
                    </> 
                    : <>
                        <rect x="0%" y="0%" rx="3" ry="5" width="100%" height="8vw"/>
                        {Array.from({ length: inputLoaderCount }).map((_, i) => (
                            <rect key={i} x="0%" y={`${15 + i * 8}%`} rx="3" ry="5" width="100%" height="4vw"/>
                        ))}
                    </>}                     
                </ContentLoader>
            </div>
        </div>
    );
}